import React from "react";
import { RefsContext } from "./provider";
export const useRefsContext = () => {
    return React.useContext(RefsContext);
};
